<div class="container">
  <h1>{{ ('browse.taxonomy_' + vocabularyName + '.title') | translate }}</h1>
  <div class="mb-3">
    <ds-vocabulary-treeview [vocabularyOptions]=vocabularyOptions
                            [multiSelect]="true"
                            (select)="onSelect($event)"
                            (deselect)="onDeselect($event)">
    </ds-vocabulary-treeview>
  </div>
  <a class="btn btn-primary"
     [routerLink]="['/search']"
     [queryParams]="queryParams"
     [queryParamsHandling]="'merge'"
     role="link"
     tabindex="0">
    {{ 'browse.taxonomy.button' | translate }}</a>
</div>
